import { SpinnerSizes, Spinner } from './Spinner';
export { SpinnerSizes, Spinner };
